import { Grid, GridItem } from '@chakra-ui/react';
import { Job, USAAProductDetailsModel } from '@ssar-app/domain';
import dayJs from 'dayjs';

export interface ProductDetailsSummaryProps {
  job?: Job;
  productDetails?: USAAProductDetailsModel;
}

export const ProductDetailsSummary = (props: ProductDetailsSummaryProps) => {
  return (
    <Grid templateColumns='repeat(6, 1fr)' gap={2}>
      {props.job && (
        <>
          <GridItem textAlign={'right'}>
            <strong>Program ID:</strong>
          </GridItem>
          <GridItem colSpan={5} marginLeft={1}>
            {props.job?.externalSystemRef || ''}
          </GridItem>
          <GridItem textAlign={'right'}>
            <strong>Project Number:</strong>
          </GridItem>
          <GridItem colSpan={5} marginLeft={1}>
            {props.job?.projectNumber || ''}
          </GridItem>
          <GridItem textAlign={'right'}>
            <strong>Message:</strong>
          </GridItem>
          <GridItem colSpan={5} marginLeft={1}>
            {props.job?.externalMessage || ''}
          </GridItem>
        </>
      )}
      <GridItem textAlign={'right'}>
        <strong>Project Name:</strong>
      </GridItem>
      <GridItem colSpan={5} marginLeft={1}>
        {props.productDetails?.programName || ''}
      </GridItem>
      <GridItem textAlign={'right'}>
        <strong>User Id:</strong>
      </GridItem>
      <GridItem colSpan={5} marginLeft={1}>
        {props.productDetails?.userId || ''}
      </GridItem>
      {props.job && (
        <>
          <GridItem textAlign={'right'}>
            <strong>Submitted By:</strong>
          </GridItem>
          <GridItem colSpan={5} marginLeft={1}>
            {props.job?.userId || ''}
          </GridItem>
        </>
      )}
      <GridItem textAlign={'right'}>
        <strong>Client Name:</strong>
      </GridItem>
      <GridItem colSpan={5} marginLeft={1}>
        {props.productDetails?.clientName || ''}
      </GridItem>
      <GridItem textAlign={'right'}>
        <strong>Client Email:</strong>
      </GridItem>
      <GridItem colSpan={5} marginLeft={1}>
        {props.productDetails?.clientEmail || ''}
      </GridItem>
      {props.job && (
        <>
          <GridItem textAlign={'right'}>
            <strong>Date Submitted:</strong>
          </GridItem>
          <GridItem colSpan={5} marginLeft={1}>
            {dayJs(props.job?.submittedDate).format(
              'YYYY-MMM-DD HH:mm:ss [GMT]ZZ',
            )}
          </GridItem>
        </>
      )}
    </Grid>
  );
};
